import classes from './viewEditEnrolledAccounts.scss';
import CheckBox from '../Common/scePSCheckBox';
import SceButton from '../../Common/CommonComponents/sceButton';
import PSErrCard from '../Common/profileSettingsErrCard';
import PaginationComponent from '../Common/PsPagination/PaginationComponent';

class ViewEditEnrolledAccounts extends React.Component {

    constructor(props){
        super(props);
        this.state={
            selectedProgram: props.selectedProgram,
            enrolledAccounts: [],
            enrolledCount: 0,
            unSelectedAccounts: props.unSelectedAccounts,
            selectAllCheck: true,
            selectAllFlow: props.selectedProgram.isSelectAll,
            currentPage: 1,
            offset: 1,
            networkErr: false
        };
        this.strings = props.strings;
        this.accountsPerPage = 10;
    }

    componentDidMount() {
        this.getListOfEnrolledAccounts();
    }

    getListOfEnrolledAccounts = () => {
        app.profileSettingsService.getListOfEnrolledAccounts(this.state.selectedProgram.category, this.state.selectedProgram.messageType, this.state.offset, this.props.bpNumber).then(
            (response)=>{
                _.each(response.preferenceSetResponse, function(eachSet){
                    if(this.state.selectAllFlow) eachSet['isSelected'] = !this.state.unSelectedAccounts.has(eachSet.objectKey);
                    else eachSet['isSelected'] = this.state.unSelectedAccounts.has(eachSet.objectKey);
                }, this);
                this.setState({enrolledAccounts: response.preferenceSetResponse, enrolledCount: response.count, selectAllCheck: this.state.selectAllFlow ? !this.state.unSelectedAccounts.size : this.state.unSelectedAccounts.size === parseInt(response.count), networkErr: false});
            }, (error)=>{
                this.setState({networkErr: true});
            });
    }

    handleCheckClick = (index) => {
        let updatedState = {...this.state};
        updatedState.enrolledAccounts[index].isSelected = !updatedState.enrolledAccounts[index].isSelected;
        if(updatedState.selectAllFlow) {            
            updatedState.enrolledAccounts[index].isSelected ? 
            updatedState.unSelectedAccounts.delete(updatedState.enrolledAccounts[index].objectKey) :
            updatedState.unSelectedAccounts.set(updatedState.enrolledAccounts[index].objectKey, updatedState.enrolledAccounts[index]);
            updatedState.selectAllCheck = !updatedState.unSelectedAccounts.size;
        } else {
            updatedState.enrolledAccounts[index].isSelected ? 
            updatedState.unSelectedAccounts.set(updatedState.enrolledAccounts[index].objectKey, updatedState.enrolledAccounts[index]) :
            updatedState.unSelectedAccounts.delete(updatedState.enrolledAccounts[index].objectKey);
            updatedState.selectAllCheck = updatedState.unSelectedAccounts.size === parseInt(updatedState.enrolledCount);
        }
        if(updatedState.selectAllCheck) {
            updatedState.selectAllFlow = true;
            updatedState.unSelectedAccounts.clear();
        }
        this.setState(updatedState);
    }

    handleSelectAllClick = () => {
        let updatedState = {...this.state};
        updatedState.selectAllCheck = !updatedState.selectAllCheck;
        updatedState.selectAllFlow = updatedState.selectAllCheck ? true : false;
        updatedState.unSelectedAccounts.clear();
        _.each(updatedState.enrolledAccounts, function(eachAccount){
            eachAccount.isSelected = updatedState.selectAllCheck;
        });
        this.setState(updatedState);
    }

    handlePageChange = (selectedPageNumber) => {
        window.aUtils.sendAAEvent("link","deactivateAccountPagination");
        //Determine offset. offset = (selected page number - 1)*10
        this.setState({offset: ((selectedPageNumber-1)*10+1)}, () => {
            //Get list of contracts from backend as per the page number.
            this.getListOfEnrolledAccounts();
        });
        document.getElementById('deactivate_account_selectAll').scrollIntoView();
    }

    getViewToShow = () => {
        let displayAccounts = this.state.enrolledAccounts.map((eachAccount, index)=>{
            let contractNumber = _.contains(['OUTGEA', 'OUTGRM'], this.state.selectedProgram.dispCategory) ? eachAccount.relationshipObjectKey : eachAccount.objectKey;
            
            let checkboxOption = <div className={classes.sceViewEditEnAccEachAcc}>{eachAccount.ojNtext.split(',').join(', ')+this.strings.viewEditAcct+contractNumber}</div>;

            return (
                <div>
                    <CheckBox id={'deactivate_account_'+eachAccount.objectKey} handleClick={()=>this.handleCheckClick(index)} selectedOptions={eachAccount.isSelected} options={checkboxOption} />
                </div>
            );
        }, this);

        displayAccounts.unshift(
            <div className={classes.sceViewEditEnAccEachAcc}>
                <CheckBox id={'deactivate_account_selectAll'} selectedOptions={this.state.selectAllCheck} handleClick={()=>this.handleSelectAllClick()}
                options={this.strings.viewEditSelectAll} />
            </div>
        );

        return displayAccounts;
    }

    render() {
        const showErrorCard = this.state.networkErr ? <PSErrCard onFormhandler={this.getListOfEnrolledAccounts} /> : null;
        const viewToShow = !this.state.networkErr ? this.getViewToShow() : null;
        const totalPages = Math.ceil(this.state.enrolledCount / this.accountsPerPage);
        return (
            <div className={classes.sceViewEditEnAcc}>
                <div className='sce-space-md'><a className={classes.sceViewEditEnAccBackLink} href="javascript:void(0);" onClick={()=>this.props.toggleViewEditView()}>{this.strings.viewEditBack}</a></div>
                {showErrorCard}
                <div className={'sce-space-md '+classes.sceViewEditEnAccHeading}>{this.state.selectedProgram.heading+this.strings.viewEditheading}</div>
                <div className={'sce-space-md '+classes.sceViewEditEnAccContent}>
                    <div className={classes.sceViewEditEnAccList}>{viewToShow}</div>
                    <div className='sce-space-md'>
                        <PaginationComponent pageCount={totalPages} getCurrentIndex={(e) => this.handlePageChange(e)} pageScale={5} value={this.state.currentPage} />
                    </div>
                </div>
                <div className='sce-space-md text-align-center'><SceButton buttonType={'primary'} value={this.strings.viewEditTurnOffAlerts} iconType='rightArrow' onClick={()=>this.props.saveUnselectedAccounts(this.state.unSelectedAccounts, this.state.selectAllFlow)} /></div>
            </div>
        );
    }
}

export default ViewEditEnrolledAccounts;